import { cn } from '@client/lib/utils';
import { isNullUndefinedOrEmpty } from '@shared';
import React from 'react';

interface CompanyLogoContainerProps {
  organizationDisplayName: string | undefined;
  containerClassName?: string;
  organizationNameClassName?: string;
  subtextClassName?: string;
  onClick?: () => void;
}

function formatOrgDisplayName(input: string): string {
  return input.replace(/\b[a-z]/g, (char, index, sentence) => {
    // Check if the previous character is an apostrophe
    if (index > 0 && sentence[index - 1] === "'") {
      return char;
    }
    return char.toUpperCase();
  });
}

const CompanyLogoContainer: React.FC<CompanyLogoContainerProps> = ({
  organizationDisplayName,
  containerClassName,
  organizationNameClassName,
  subtextClassName,
  onClick,
}) => {
  return (
    <div
      className={cn(
        containerClassName,
        'mr-5 flex flex-col items-start',
        onClick && 'cursor-pointer',
      )}
      id="white-label-container"
      onClick={onClick}
    >
      {!isNullUndefinedOrEmpty(organizationDisplayName) ? (
        <>
          {/** Do not remove whitelabel-logo id, it is used for pdf report generation */}
          <div
            id="whitelabel-logo"
            className={
              organizationNameClassName
                ? organizationNameClassName
                : 'text-primary-dark text-sm font-semibold md:text-base'
            }
          >
            {formatOrgDisplayName(organizationDisplayName)}
          </div>
          <div className={subtextClassName ? subtextClassName : 'text-xs text-gray-700 md:text-sm'}>
            powered by Waterlily
          </div>
        </>
      ) : (
        <div className="mt-2  text-2xl font-semibold text-gray-800 md:text-3xl">Waterlily</div>
      )}
    </div>
  );
};

export default CompanyLogoContainer;
